/**
 * 新增規則的範本（AGUI-1113）。
 *
 * 第一次設定最卡的是面對空白表單不知道填什麼；範本把常見情境先填好，使用者只補缺的那一格。
 * 範本只是預填草稿：一律打開表單讓使用者確認後才儲存，不直接幫他建立，
 * 這樣他看得到規則長什麼樣子，之後也知道怎麼自己設定。
 *
 * - `rule`：帶進 MailRuleForm 的 `initial`，欄位同 EMPTY_RULE
 * - `focusId`：打開後游標停在哪一格（範本留白、要使用者補的那格）
 * - `senderMode`：寄件者輸入列一開始的類型（company／email／domain），沒給就是公司帳號
 *
 * 10-06 拿掉表單頂端的範本提示框：表單版面固定，要補的寄件者欄下方顯示 step2 引導（10-07 拿掉藍框），
 * 預填過的選填群組（關鍵字、重要性、AI）打開時自動展開，使用者看得到範本幫他填了什麼。
 * 寄件者必填（AGUI-1113）：範本不預填寄件者（AI 範本例外），游標停在寄件者輸入列。
 */

export const MAIL_RULE_TEMPLATES = [
  {
    id: 'sender',
    title: '特定人員來信',
    desc: '主管、客戶寄來的信',
    rule: { ruleName: '特定人員來信' },
    focusId: 'mail-rule-from',
  },
  {
    id: 'domain',
    title: '特定公司來信',
    desc: '某個網域寄來的所有信',
    rule: { ruleName: '特定公司來信' },
    focusId: 'mail-rule-from',
    senderMode: 'domain',
  },
  {
    id: 'keyword',
    title: '主旨含關鍵字',
    desc: '指定寄件者、主旨含特定字詞的信',
    rule: { ruleName: 'MyBro 相關信件', subjectKeywords: ['MyBro'] },
    focusId: 'mail-rule-from',
  },
  {
    // 信件本身就帶的屬性，不必猜關鍵字（會議決議保留）
    id: 'importance',
    title: '高重要性信件',
    desc: '指定寄件者標為「高重要性」的信',
    rule: { ruleName: '高重要性信件', importance: 'high' },
    focusId: 'mail-rule-from',
  },
  {
    id: 'ai',
    title: 'AI 判讀信件',
    desc: '指定寄件者的信，交給 AI 判斷是否通知',
    // 唯一預填寄件者的範本（10-06 使用者裁決）：範例本身就是 MyBro 寄來的信，寄件者已知，游標改停在 AI 描述
    // 信箱用小寫：寄件者清單加入時一律轉小寫，大小寫不同會躲過重複檢查
    rule: {
      // 10-20：AI 判讀只決定要不要通知，不會摘要信件，範例描述改成判斷條件（原「摘要內容給我」會讓人誤會）
      ruleName: 'MyBro 功能通知',
      fromAddresses: ['mybro@taiwanmobile.com'],
      aiPrompt: '介紹 MyBro 功能的信才通知我',
    },
    focusId: 'mail-rule-ai',
  },
];
